module.exports = __webpack_public_path__ + "static/media/active-pin.1639a9f8.svg";